var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIPill03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.09285 17.9957C5.03937 20.3199 5.26146 23.8692 7.58759 25.9212C9.91655 27.9766 13.4665 27.7498 15.5136 25.4265L20.5556 19.7136L18.5984 14.0886L12.1366 12.2814L7.09285 17.9957Z",
    fill: "#99D9DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1739 6.5657L12.1318 12.2801L20.5523 19.7125L20.5539 19.7127L25.596 13.9982C27.6497 11.6724 27.4276 8.12313 25.103 6.07135C22.7843 4.02491 19.2324 4.2388 17.1755 6.56586L17.1739 6.5657Z",
    fill: "#00A1A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIPill03);
export default __webpack_public_path__ + "static/media/i_pill_03.a1605fdc99c5e54ee9e314f5ad709644.svg";
export { ForwardRef as ReactComponent };